import { call, put } from 'redux-saga/effects'
import { toast } from 'react-toastify'
import {
  listUsers,
  getUserById,
  createUser,
  updateUser,
} from '../requests/rewardService'
import {
  setUsers,
  setUserDetail,
  setLoading,
  setError,
  setCreateLoading,
  setUpdateLoading,
} from '../../slices/rewardUsersSlice'

function getErrorMessage(e) {
  try {
    const msg = e.response?.data?.message || e.response?.data?.error || e.message
    return typeof msg === 'string' ? msg : String(msg)
  } catch {
    return 'An unexpected error occurred'
  }
}

export function* handleFetchUsers(action) {
  try {
    yield put(setLoading(true))
    const params = { page: 1, per_page: 10, ...action.payload }
    const { data } = yield call(listUsers, params)
    yield put(setUsers(data))
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    yield put(setError(errorMsg))
    toast.error(errorMsg)
  }
}

export function* handleFetchUserById(action) {
  try {
    yield put(setLoading(true))
    const { data } = yield call(getUserById, action.payload)
    yield put(setUserDetail(data))
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    yield put(setError(errorMsg))
    toast.error(errorMsg)
  }
}

export function* handleCreateUser(action) {
  try {
    yield put(setCreateLoading(true))
    yield call(createUser, action.payload)
    yield put(setCreateLoading(false))
    toast.success('User created successfully')
  } catch (e) {
    yield put(setCreateLoading(false))
    const errorMsg = getErrorMessage(e)
    toast.error(errorMsg)
    yield put(setError(errorMsg))
  }
}

export function* handleUpdateUser(action) {
  try {
    const { id, data } = action.payload
    yield put(setUpdateLoading(true))
    yield call(updateUser, id, data)
    yield put(setUpdateLoading(false))
    toast.success('User updated successfully')
  } catch (e) {
    yield put(setUpdateLoading(false))
    const errorMsg = getErrorMessage(e)
    toast.error(errorMsg)
    yield put(setError(errorMsg))
  }
}
